import { Auth } from '@edge/spark/io-aws'

import updateUser from '../helpers/updateUser'
import saveUser from './saveUser'
import { isErrorLike } from '../../../utils/isErrorLike'

import {
    LoginCredentials,
    LoginResponseTypes,
    MutationResolvers,
    LoginResponse,
    UpdateBiRolesMutation,
    UpdateBiRolesDocument as mutation,
} from '../../../generated/graphql'
import { createDialog } from '@edge/spark/feature-dialog'
import { getActiveAuctionId } from '@edge/spark/io-roles'

const doLogin: MutationResolvers['doLogin'] = async (_root, { credentials }, { client }): Promise<LoginResponse> => {
    if (!client) {
        throw new Error('Missing client context')
    }

    const cleanCredentials: LoginCredentials = {
        username: credentials.username.trim().toLowerCase(),
        password: credentials.password.trim(),
    }

    try {
        const user = await Auth.signIn(cleanCredentials)

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
            saveUser.user = user
            saveUser.password = credentials.password
            return {
                result: LoginResponseTypes.NewPasswordRequired,
            }
        }
    } catch (error) {
        console.error('doLogin error. Signing out...', error)
        await Auth.signOut()
        const message = isErrorLike(error) ? error.message : 'Login Internal Error'

        createDialog({
            heading: 'Login failed',
            message,
            type: 'ALERT',
        })

        return {
            result: LoginResponseTypes.Failure,
            message,
        }
    }

    try {
        await updateUser()
        const auctionId = getActiveAuctionId()
        await client.mutate<UpdateBiRolesMutation>({
            mutation,
            variables: { auctionId },
        })
        return { result: LoginResponseTypes.Success }
    } catch (error) {
        const message = isErrorLike(error) ? error.message : 'Update User Internal Error'

        createDialog({
            heading: 'Login failed',
            message,
            type: 'ALERT',
        })

        return {
            result: LoginResponseTypes.Failure,
            message,
        }
    }
}

export default doLogin
